import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    closeTabRef,
    VerificationService,
} from '@sheerid/jslib';
import { LogoComponent } from '../LogoComponent/LogoComponent';


interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    // Close any open tab for SSO login
    closeTabRef();

    const hasLogo = verificationService.programTheme.logoUrl ? true : false;
    const redirectPrincessHomepage = 'https://www.princess.com/';
    const redirectCruiseSearch = 'https://www.princess.com/cruise-search/cruises';

    return (
        <div id="sid-step-success" className="sid-l-container" role="main">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo ?
                        <LogoComponent verificationService={verificationService} />
                        :
                        <img
                            className="sid-l-lead-image"
                            alt="design element"
                            src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                        />
                    }
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <h1>
                        <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                    </h1>
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <h2>
                        <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                            `We verified your eligibility for the
                            special offer you requested`
                        } />
                    </h2>
                </div>

                <div className="sid-submit sid-success-cruise-personalizer-button sid-l-space-top-md">
                    <button
                        onClick={() => redirect(redirectPrincessHomepage)}
                        className="sid-btn sid-btn--dark"
                    >
                        <FormattedHTMLMessage id="step.success.redirectCruisePersonalizer" defaultMessage="Continue to Princess Cruises" />
                    </button>
                </div>
            </div>

            <div className="sid-success-body sid-success-body__one sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only. <br>
                        Now that you've been approved, please review the
                        Princess military benefit program
                        <a href="https://www.princess.com/military_benefit_program/">terms and conditions</a>.
                    `}
                />
            </div>

            <div className="sid-success-body sid-success-body__two sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage={`
                    Please allow up to 7 days to view this benefit on your booking in
                    <a href="https://book.princess.com/cruisepersonalizer/index.page">Cruise Personalizer</a>
                `} />
            </div>

            <div className="sid-success-body sid-success-body__three sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.noCurrentBooking" defaultMessage={`
                    If you do not have a current booking, we'd love to see you on board soon!
                `} />
            </div>


            <div className="sid-submit sid-success-cruise-search-button sid-l-space-top-md">
                <button
                    onClick={() => redirect(redirectCruiseSearch)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectCruiseSearch" defaultMessage="Find Your Next Cruise Adventure" />
                </button>
            </div>
        </div>
    );
};

export { StepSuccessComponent };
